const Config = {
	comparisonValueLookup: {
		eq: "Equals",
		ne: "Does not equal",
		contains: "Contains",
		notcontains: "Not contains",
		startswith: "Starts with",
		notstartswith: "Does not start with",
		endswith: "Ends with",
		notendswith: "Does not end with",
		before: "Before",
		after: "After",
		gt: "Greater than",
		gte: "Greater than or equal",
		lt: "Less than",
		lte: "Less than or equal",
	},
	fieldTypeOptionsLookup: {
		text: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
			{ value: "startswith", label: "Starts with" },
			{ value: "notstartswith", label: "Does not start with" },
			{ value: "endswith", label: "Ends with" },
			{ value: "notendswith", label: "Does not end with" },
		],
		textbox: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
			{ value: "startswith", label: "Starts with" },
			{ value: "notstartswith", label: "Does not start with" },
			{ value: "endswith", label: "Ends with" },
			{ value: "notendswith", label: "Does not end with" },
		],
		date: [
			{ value: "eq", label: "Equals" },
			{ value: "before", label: "Before" },
			{ value: "after", label: "After" },
		],
		person: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		manager: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		department: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		template: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		cycle: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		numeric: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "gt", label: "Greater than" },
			{ value: "gte", label: "Greater than or equal to" },
			{ value: "lt", label: "Less than" },
			{ value: "lte", label: "Less than or equal to" },
		],
		"multi-select": [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
		],
		"single-select": [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		people: [
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
		],
		boolean: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		status: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		monetary: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "gt", label: "Greater than" },
			{ value: "gte", label: "Greater than or equal to" },
			{ value: "lt", label: "Less than" },
			{ value: "lte", label: "Less than or equal to" },
		],
		salary: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "gt", label: "Greater than" },
			{ value: "gte", label: "Greater than or equal to" },
			{ value: "lt", label: "Less than" },
			{ value: "lte", label: "Less than or equal to" },
		],
		phone: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
		],
		email: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
			{ value: "contains", label: "Contains" },
			{ value: "notcontains", label: "Does not contain" },
		],
		goal: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		goalCategories: [
			// eq is the actual value, but "Contains" reads better since categories is an array field
			{ value: "eq", label: "Contains" },
			{ value: "ne", label: "Does not contain" },
		],
		goalOutlook: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
		goalTransparency: [
			{ value: "eq", label: "Equals" },
			{ value: "ne", label: "Does not equal" },
		],
	},
	categoryOptions: [
		{
			value: "EMPLOYEE_FIELD",
			label: "Employee Field",
		},
		{
			value: "GOAL_FIELD",
			label: "Goal Field",
			statuses: [
				{ label: "Active", value: "active" },
				{ label: "Completed", value: "done" },
				{ label: "Archived", value: "archived" },
			],
			fields: [
				{
					_id: "assignee",
					name: "Assignee",
					type: "person",
				},
				{
					_id: "assignee.name",
					name: "Assignee Name",
					type: "text",
				},
				{
					_id: "name",
					name: "Goal Name",
					type: "text",
				},
				{
					_id: "status",
					name: "Status",
					type: "status",
				},
				{
					_id: "last_goal_status_update",
					name: "Last Status Update",
					type: "date",
				},
				{
					_id: "categories",
					name: "Categories",
					type: "goalCategories",
				},
				{
					_id: "start_date",
					name: "Start Date",
					type: "date",
				},
				{
					_id: "end_date",
					name: "Due Date",
					type: "date",
				},
				{
					_id: "outlook",
					name: "Outlook",
					type: "goalOutlook",
				},
				{
					_id: "value",
					name: "Current Value",
					type: "numeric",
				},
				{
					_id: "target",
					name: "Target",
					type: "numeric",
				},
				{
					_id: "current_progress",
					name: "Current Progress",
					type: "numeric",
				},
				{
					_id: "transparency",
					name: "Transparency",
					type: "goalTransparency",
				},
				{
					_id: "alignment",
					name: "Alignment",
					type: "goal",
				},
				{
					_id: "alignment.assignee",
					name: "Alignment Assignee",
					type: "person",
				},
				{
					_id: "assignee.group",
					name: "Assignee Group",
					type: "department",
				},
				{
					_id: "creation_date",
					name: "Creation Date",
					type: "date",
				},
			],
		},
		{
			value: "REVIEW_FIELD",
			label: "Review Field",
			statuses: [
				{ value: "Completed", label: "Completed" },
				{ value: "Active", label: "Active" },
				{ value: "Scheduled", label: "Scheduled" },
			],
			fields: [
				{
					_id: "name",
					name: "Review Name",
					type: "text",
				},
				{
					_id: "subject.name",
					name: "Subject Name",
					type: "text",
				},
				{
					_id: "subject",
					name: "Subject",
					type: "person",
				},
				{
					_id: "status",
					name: "Review Status",
					type: "status",
				},
				{
					_id: "start_date",
					name: "Start Date",
					type: "date",
				},
				{
					_id: "completed_date",
					name: "Completed Date",
					type: "date",
				},
				{
					_id: "participants",
					name: "Participants",
					type: "people",
				},
				{
					_id: "easy_add_enabled",
					name: "360 Enabled",
					type: "boolean",
				},
				{
					_id: "forms_awaiting_approval",
					name: "Forms Awaiting Approval",
					type: "numeric",
				},
			],
		},
		{
			value: "REVIEW_CYCLE_FIELD",
			label: "Review Cycle Field",
			statuses: [
				{ value: "completed", label: "Completed" },
				{ value: "active", label: "Active" },
				{ value: "scheduled", label: "Scheduled" },
			],
			fields: [
				{
					_id: "review_cycle",
					name: "Review Cycle",
					type: "cycle",
				},
				{
					_id: "name",
					name: "Cycle Name",
					type: "text",
				},
				{
					_id: "group",
					name: "Cycle Group",
					type: "department",
				},
				{
					_id: "status",
					name: "Cycle Status",
					type: "status",
				},
				{
					_id: "start_date",
					name: "Cycle Start Date",
					type: "date",
				},
				{
					_id: "template.name",
					name: "Template Name",
					type: "text",
				},
				// TODO: add is_360_enabled Review Cycle field to column picker
				// {
				// 	_id: "is_360_enabled",
				// 	name: "360 Enabled",
				// 	type: "boolean",
				// },
			],
		},
		{
			value: "REVIEW_FORM_FIELD",
			label: "Review Form Field",
			statuses: [
				{ value: "completed", label: "Completed" },
				{ value: "deleted", label: "Deleted" },
				{ value: "in-progress-awaiting-authors", label: "Awaiting Authors" },
				{ value: "in-progress-awaiting-signoff", label: "Awaiting Signers" },
				{ value: "not-started", label: "Not Started" },
			],
			fields: [
				{
					_id: "authors_due_date",
					name: "Author's Due Date",
					type: "date",
				},
				{
					_id: "signers_due_date",
					name: "Signer's Due Date",
					type: "date",
				},
				{
					_id: "name",
					name: "Form Name",
					type: "text",
				},
				{
					_id: "authors",
					name: "Authors",
					type: "people",
				},
				{
					_id: "signers",
					name: "Signers",
					type: "people",
				},
				// TODO: add visible_to_subject Review Form field to column picker
				// {
				// 	_id: "visible_to_subject",
				// 	name: "Visible to Subject",
				// 	type: "boolean",
				// },
				// TODO: add readt_authors Review Form field to column picker
				// {
				// 	_id: "redact_authors",
				// 	name: "Redact Authors",
				// 	type: "boolean",
				// },
				{
					_id: "review_template",
					name: "Review Template",
					type: "template",
				},
				{
					_id: "status",
					name: "Form Status",
					type: "status",
				},
				{
					_id: "completed_date",
					name: "Form Complete Date",
					type: "date",
				},
				{
					_id: "signing_completed_at",
					name: "Signed Date",
					type: "date",
				},
				{
					_id: "authoring_completed_at",
					name: "Authored Date",
					type: "date",
				},
			],
		},
		{
			value: "SURVEY_FIELD",
			label: "Survey Field",
			statuses: [
				{ value: "closed", label: "Closed" },
				{ value: "active", label: "Active" },
				// { value: "scheduled", label: "Scheduled" },
			],
			fields: [
				{
					_id: "survey_name",
					name: "Survey Name",
					type: "text",
				},
				{
					_id: "survey_status",
					name: "Status",
					type: "status",
				},
				{
					_id: "survey_start_date",
					name: "Start Date",
					type: "date",
				},
				{
					_id: "survey_end_date",
					name: "End Date",
					type: "date",
				},
				{
					_id: "survey_creation_date",
					name: "Creation Date",
					type: "date",
				},
				{
					_id: "survey_creator_id",
					name: "Creator",
					type: "person",
				},
				{
					_id: "survey_creator_id",
					name: "Creator Name",
					type: "text",
				},
				{
					_id: "survey_published_date",
					name: "Published Date",
					type: "date",
				},
				{
					_id: "participant._id",
					name: "Participant",
					type: "person",
				},
				{
					_id: "participant.name",
					name: "Participant Name",
					type: "text",
				},
				{
					_id: "participant_submitted_date",
					name: "Participant Submitted Date",
					type: "date",
				},
			],
		},
	],
	allowedFieldTypes: {
		employeeReport: ["EMPLOYEE_FIELD"],
		reviewReport: ["EMPLOYEE_FIELD", "REVIEW_FIELD", "REVIEW_CYCLE_FIELD", "REVIEW_FORM_FIELD"],
		goalReport: ["EMPLOYEE_FIELD", "GOAL_FIELD"],
		surveyReport: ["SURVEY_FIELD", "EMPLOYEE_FIELD"],
	},
};

export default Config;
